export default function translateEnum(enumName, key){
    return this.translate(enumName, null, key, true);
}
